import { ref, onMounted, computed } from 'vue'
import useApp from './useApp'
import router from '@/router'
import { useStore } from 'vuex'
import axios from '@/axios'


const useLogin = () => {

  const store = useStore()
  const {
    host,
    route,
    validEmail,
    ToastMsgError,
    ToastMsgSuccess,
    getQueryParam,
    showPassword
  } = useApp()


  const data = ref({
    user: {
      email: "",
      password: ""
    }
  })

  let errors = [];


  onMounted(() => {
    const email = decodeURIComponent(getQueryParam("email"));
    const password = decodeURIComponent(getQueryParam("password"));
    if (email != "email" && password != "password") {
      data.value.user.email = email
      data.value.user.password = password
      check_form()
    }

    setTimeout(() => {

    }, 1000)

  })


  const check_form = () => {
    errors = [];

    if (!data.value.user.email) {
      errors.push("- Campo Email Vacio !")

    } else if (!validEmail(data.value.user.email)) {
      errors.push("- Email Invalido !")
    }

    else if (!data.value.user.password) {
      errors.push("- Campo de Contraseña Vacio !")
    }

    else if (errors.length == 0) {
      login()
    }

    errors.map(err => {
      ToastMsgError(err, "user", 5000)
    })

  }

  const login = () => {
    axios
      .post("/login", data.value.user)
      .then(res => {

        //success! - Usuario creado.
        if (res.data.status == "success") {

          ToastMsgSuccess(`"Bienvenido ${res.data.userData.name}"`, "user", 5000)

          const auth = {
            token: res.data.token,
            userData: res.data.userData
          }
          //token to de store - token a la tienda
          store.commit('setAuth', auth);
          //set auth object in localStorage - Grabamos el token en localStorage
          localStorage.setItem('auth', JSON.stringify(auth));
          router.push("/");
          return;
        }

      })
      .catch(e => {

        if (e.response == undefined) {
          ToastMsgError("Error Api Server", "server", 5000)
        }
        else if (e.response.data.error == "Invalid Credentials") {

          ToastMsgError("Credenciales Invalidas", "user", 5000)
          return

        } else if (e.response.data.status == "no-active") {
          ToastMsgError(`"${e.response.data.error}"`, "user", 5000)
          return

        } else if (e.response.data.status == "error"){
          ToastMsgError(`"${e.response.data.error}"`, "user", 5000)
        }
        else {
          ToastMsgError("Undefined Error !", "server", 5000)
        }
      });

  }


  return {
    data,
    check_form,
    showPassword
  }

}

export default useLogin